import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../core/services/base-api.service';
import { AppConfigService } from '../../core/services/app-config.service';

export interface Campaign {
  id: string;
  name: string;
}

export interface CampaignPerformance {
  campaignName: string;
  sent: number;
  delivered: number;
  opened: number;
  bounced: number;
  clicked: number;
  unsubscribes: number;
}

export interface CampaignPerformanceRate {
  campaignName: string;
  openRate: number;
  ctor: number; // Click To Open Rate
  ctr: number;  // Click Through Rate
  unsubscribeRate: number;
  bounceRate: number;
}

@Injectable({
  providedIn: 'root'
})
export class CampaignService extends BaseApiService {
  constructor(http: HttpClient, appConfigService: AppConfigService) {
    super(http, appConfigService);
  }

  /**
   * Get campaigns for a specific date range and campaign type
   * @param fromDate Start date in YYYYMM format
   * @param toDate End date in YYYYMM format
   * @param campaignType Numeric campaign type (default 1)
   * @returns Observable of Campaign array
   */
  getCampaigns(fromDate: string, toDate: string, campaignType: number = 1): Observable<Campaign[]> {
    return this.get<Campaign[]>(`master/campaigns?fromDate=${fromDate}&toDate=${toDate}&CampaignType=${campaignType}`);
  }

  /**
   * Get performance data for a specific campaign
   * @param campaignId Campaign ID
   * @param fromDate Start date in YYYYMM format
   * @param toDate End date in YYYYMM format
   * @returns Observable of CampaignPerformance array
   */
  getCampaignPerformance(campaignId: string, fromDate: string, toDate: string): Observable<CampaignPerformance[]> {
    return this.get<CampaignPerformance[]>(`campaigns/campaign-performance?campaignId=${campaignId}&fromDate=${fromDate}&toDate=${toDate}`);
  }
} 